export default "__VITE_ASSET__ea49df47__"